import Details from "./details/Details";
import "./productdetails.css";
import Rates from "./rating/Rates";
import RelatedProduct from "./related/RelatedProduct";
import * as Product from "../../network/api/product";
import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {view} from "../../network/api/user";
import {createContext} from "react";

export const AddContext = createContext();
function Productdetails(props) {
	let {id} = useParams();
	const [product, setProduct] = useState(null);
	const [addedCart, setAddedCart] = useState(false);

	const getProduct = () => {
		Product.getProduct(id).then(product => {
			setProduct(product.data);
		});
	};
	useEffect(() => {
		if (id.length === 24) getProduct();
		view(id);
	}, [id]);

	return (
		<div
			className="product-details"
			style={{direction: "rtl"}}
		>
			<div className="container">
				<AddContext.Provider value={{addedCart, setAddedCart}}>
					<Details
						product={product}
						personal={props.personal}
						update_p={props.update_p}
					/>
				</AddContext.Provider>
				<div className="border-top">
					<Rates
						product={product}
						getProduct={getProduct}
					/>
					{/* <RelatedProduct personal={props.personal} update_p={props.update_p} product={product} /> */}
				</div>
			</div>
			{addedCart && (
				<div className="d-md-none">
					<div className="popy d-flex flex-column-reverse">
						<div className="pop w-100 bg-white">
							<p
								className="cancel fs-1 p-4"
								onClick={() => setAddedCart(false)}
							>
								x
							</p>
							<div className="name px-4 d-flex gap-2">
								<span>تيشيرت بولو مطبع</span>
								<span style={{color: "#D99D2B"}}>
									تم الاضافة للسلة{" "}
								</span>
							</div>
							<div className="d-flex flex-column px-4">
								<button className="resume">اكمل التسوق</button>
								<button className="pay">الدفع</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
export default Productdetails;
